import React, { useEffect, Fragment } from 'react';
import cookie from 'react-cookies';
import useGlobal from '../../store';
import { Routes, Route, BrowserRouter }	from 'react-router-dom';
import Sign from './sign';
import Company from './company';
import Companies from './companies';

const AppRouter = () => {

	return (

		<Fragment>

		<BrowserRouter>

			<Routes>

        <Route exact path="/"              element={<Protected><Companies/></Protected>} />
        <Route exact path="/sign"          element={<Sign/>} />
        <Route exact path="/companies"     element={<Protected><Companies/></Protected>} />
        <Route exact path="/companies/:id" element={<Protected><Company /></Protected>} />

      </Routes>

    </BrowserRouter>

		</Fragment>

  );

};

const Protected = ({ children }) => {

	const [ globalState, globalActions ] = useGlobal();
	const token = cookie.load('token');

	useEffect(() => { 
    //// console.log(`Protected token = `, token);		
		token 
			? globalActions.sign.Check( token )
			: globalActions.sign.Out()
	
	}, []);

	return children;

}

export default AppRouter;